import { Component, OnInit, OnDestroy, HostListener } from '@angular/core';
import {AppSettings} from '../../app-settings';
import {HttpClientService} from '../../Services/http-client.service';
import { HttpHeaders } from '@angular/common/http';
import { DomSanitizer } from '@angular/platform-browser';
import {SessionService} from '../../Services/session.service';
import {Subscription} from 'rxjs';
import { trigger, style, animate, transition } from '@angular/animations';
import { EventService } from "../../Services/event.service";

@Component({
  selector: 'app-notes',
  templateUrl: './notes.component.html',
  styleUrls: ['../bookmarks/bookmarks.component.css','../forum-post/forum-post.component.css','./notes.component.css'],
  animations: [
  trigger('coursePopUpInOut', [
   transition(':enter', [
         style({opacity: 0}),
         animate('0.3s', style({opacity: 1}))
       ]),
   transition(':leave', [
         style({opacity: 1}),
         animate('0.3s', style({opacity: 0}))
       ])
   ])
  ]
})
export class NotesComponent implements OnInit, OnDestroy {

	tabPro:String = "tabPro";
	tabSec:String = "tabSec";
  tabArc:String = "tabArc";
	tabActive:String ="tabPro";
  profileTabImg  = AppSettings.cdnUrl +"assets/images/play-button-bg.png";
  securityTabimg = AppSettings.cdnUrl+"assets/images/test-bg.png";
  ArcTabimg = AppSettings.cdnUrl+"assets/images/archived-tab-icon.png"
  deleteImageRed  = AppSettings.cdnUrl+"assets/images/delete_red_btn.png";
  loadingCircleURL = AppSettings.loadingCircleImageURL;
  dataLoaded:boolean = true;
  searchNotes:string  = '';
  showFullNote:boolean=false;
  fullNote:object={};
  noteIndex:number=0;

    options:any = [{"displayName":"Verbal Section", "type":"VERBAL","id":"VerbalSection","verbalFirstList":false,
                  "optionsSecondary":[{"displayName":"Sentence Correction", "type":"SC","id":"SC"},{"displayName":"Crtical Reasoning", "type":"CR","id":"CR"},
                    {"displayName":"Reading Comprehension", "type":"RC","id":"RC"}]},

                  {"displayName":"Quant Section", "type":"QUANT","id":"QuantSection",
                  "optionsSecondary":[{"displayName":"Advanced Topics", "type":"Advanced Topics","id":"AT"},{"displayName":"Algebra", "type":"Algebra","id":"ALG"},
                    {"displayName":"Geometry", "type":"Geometry","id":"GEO"},{"displayName":"Number Properties", "type":"Number Properties","id":"NP"},
                    {"displayName":"Word Problems", "type":"Word Problems","id":"WP"}]}];

    selectModeOn:boolean  =false;
    searchModeOn:boolean = false;
    searchQuery:string;
    deleteImage = AppSettings.cdnUrl +"assets/images/delete-btn.png";
    closePopUpIcon = AppSettings.cdnUrl + "assets/images/close_pop_filled.png";
    notesConcept = [];
    notesConceptAll = [];
    notesArchivedConcept = [];
    notesArchivedAll = [];
    notesQuiz = [];
    notesQuizAll = [];
    notesConceptObject:any={};
    notesArchivedConceptObject:any={};
    questionCharacterCount:number = 121;
    notesConceptDummy  = [];
    notesArchivedConceptDummy = [];
    notesQuizDummy  = [];
    activeOptions = [];
    statusFilterBy:string = "subject";
    filterCount: number = 0;
    serverErrorFlag = false;
    serverErrorFlagConcepts:boolean = false;
    serverErrorFlagNotes:boolean = false;
    userInfoSubscription:Subscription;
    userEmail:string;

  constructor(private httpClientService: HttpClientService , private sanitizer: DomSanitizer , private sessionService: SessionService, private eventService: EventService) { }

  ngOnInit() {

    this.getNotesThreadData();
    this.getFullName();
  }

  getFullName()
  {

    this.userInfoSubscription = this.sessionService.getUserInfo$.
    subscribe(data => { if(data != "")
     this.userEmail = data.username;
     if(this.userEmail)
     {
        this.fireAccessedEvent();
     }
      });

   }

  fireAccessedEvent()
  {
    this.eventService.track('Accessed_User_Info', {"Accessed_Reason":"notes"}, this.userEmail);
  }

  getNotesThreadData()
  {
      this.getConceptNotes();
      this.getQuizNotes();
      this.getArchivedConceptNotes();
  }

  getConceptNotes()
  {
          let headers = new HttpHeaders();
      this.httpClientService.get(AppSettings.restApiUrl+'/api/user/concepts/archived/false/notes/'
          , headers)
      .subscribe(
      (data) => {
                  this.notesConcept = [];
                  if(data.notesVO != null)
                  {
                  this.notesConceptDummy = data.notesVO;
                  var conceptNotesLength = this.notesConceptDummy.length;
                  for(var i=0; i<conceptNotesLength;i++)
                  {
                      this.notesConceptObject = {};
                      if(this.notesConceptDummy[i].note != null)
                      {
                        this.notesConceptObject.note = this.sanitizer.bypassSecurityTrustHtml(this.notesConceptDummy[i].note.replace(/<\s*(\w+).*?>/, '<$1>'));
                      }
                      else
                      {
                        this.notesConceptObject.note = this.sanitizer.bypassSecurityTrustHtml(null);
                      }
                      this.notesConceptObject.conceptName = this.notesConceptDummy[i].conceptName;
                      this.notesConceptObject.notesDate = this.notesConceptDummy[i].notesDate;
                      this.notesConceptObject.url = this.notesConceptDummy[i].url;
                      this.notesConceptObject.hoverOver = false;
                      this.notesConceptObject.id = this.notesConceptDummy[i].id;
                      this.notesConceptObject.subject = this.notesConceptDummy[i].subject;
                      this.notesConcept.push(this.notesConceptObject);
                  }
                  this.notesConceptAll = this.notesConcept;
                  }
                  this.dataLoaded = false;
      },(e)=>{

          if(e.status == 500)
          {
             this.serverErrorFlagConcepts = true;
          }
          this.dataLoaded = false;
      });
  }
  getArchivedConceptNotes()
  {
          let headers = new HttpHeaders();
      this.httpClientService.get(AppSettings.restApiUrl+'/api/user/concepts/archived/true/notes/'
          , headers)
      .subscribe(
      (data) => {
                  this.notesArchivedConcept = [];
                  if(data.notesVO != null)
                  {
                  this.notesArchivedConceptDummy = data.notesVO;
                  var conceptNotesLength = this.notesArchivedConceptDummy.length;
                  for(var i=0; i<conceptNotesLength;i++)
                  {
                      this.notesArchivedConceptObject = {};
                      if(this.notesArchivedConceptDummy[i].note != null)
                      {
                        this.notesArchivedConceptObject.note = this.sanitizer.bypassSecurityTrustHtml(this.notesArchivedConceptDummy[i].note.replace(/<\s*(\w+).*?>/, '<$1>'));
                      }
                      else
                      {
                        this.notesArchivedConceptObject.note = this.sanitizer.bypassSecurityTrustHtml(null);
                      }
                      this.notesArchivedConceptObject.conceptName = this.notesArchivedConceptDummy[i].conceptName;
                      this.notesArchivedConceptObject.notesDate = this.notesArchivedConceptDummy[i].notesDate;
                      this.notesArchivedConceptObject.url = this.notesArchivedConceptDummy[i].url;
                      this.notesArchivedConceptObject.hoverOver = false;
                      this.notesArchivedConceptObject.id = this.notesArchivedConceptDummy[i].id;
                      this.notesArchivedConceptObject.subject = this.notesArchivedConceptDummy[i].subject;
                      this.notesArchivedConcept.push(this.notesArchivedConceptObject);
                  }
                  this.notesArchivedAll = this.notesArchivedConcept;
                  }
                  this.dataLoaded = false;
      },(e)=>{

          if(e.status == 500)
          {
             this.serverErrorFlagConcepts = true;
          }
          this.dataLoaded = false;
      });
  }
  getQuizNotes()
  {
    let header = new HttpHeaders();
      this.httpClientService.get(AppSettings.restApiUrl+'/api/user/quiz/notes/'
          , header)
      .subscribe(
      (data) => {
                  this.notesQuiz = [];
                  if(data.notesVO != null)
                  {
                  this.notesQuizDummy = data.notesVO;
                  var quizNotesLength = this.notesQuizDummy.length;
                  for(var i=0; i<quizNotesLength;i++)
                  {
                      this.notesConceptObject = {};
                      this.notesConceptObject.id = this.notesQuizDummy[i].noteid;
                      this.notesConceptObject.note = this.sanitizer.bypassSecurityTrustHtml(this.notesQuizDummy[i].note.replace(/<\s*(\w+).*?>/, '<$1>'));
                      this.notesConceptObject.quizName = this.notesQuizDummy[i].quizName;
                      this.notesConceptObject.notesDate = this.notesQuizDummy[i].notesDate;
                      this.notesConceptObject.url = this.notesQuizDummy[i].url;
                      this.notesConceptObject.hoverOver = false;
                      this.notesConceptObject.subject = this.notesQuizDummy[i].subject;
                      this.notesConceptObject.quizApplication = this.notesQuizDummy[i].quizApplication;
                      this.notesQuiz.push(this.notesConceptObject);
                  }
                  this.notesQuizAll = this.notesQuiz;
                  }
                  this.dataLoaded = false;
      },(e)=>{

          if(e.status == 500)
          {
             this.serverErrorFlagNotes = true;
          }
          this.dataLoaded = false;
      });
  }
  toggle(tabName:String, vevent)
  {

  	this.tabActive = tabName;
  }
   toggleSelect()
  {
    this.selectModeOn = !this.selectModeOn;
  }
  deleteConceptNote(noteId)
  {
  	//dataArray.splice(index,1);
    let headers = new HttpHeaders();
    this.httpClientService.post(AppSettings.restApiUrl +
          '/api/notes/delete/'+noteId+'/',null, headers)
      .subscribe(
      (data) => {

          this.getConceptNotes();
          this.getArchivedConceptNotes();
      }
      );
  }
  deleteQuizNotes(noteId,quizApplication)
  {
    var url = '';
    if(quizApplication == "SCHOLARANIUM")
    {
      url = '/api/user/quiz/scholaranium/notes/delete/'+noteId+'/';
    }
    else if (quizApplication == "MIQA")
    {
      url = '/api/user/quiz/miqa/notes/delete/'+noteId+'/';
    }
    let headers = new HttpHeaders();
    this.httpClientService.post(AppSettings.restApiUrl +
          url,null, headers)
      .subscribe(
      (data) => {

          this.getQuizNotes();
      }
      );
  }
  searchChange($event)
  {
    if ($event)
    {
      this.searchModeOn = true;
    }
    else
    {
      this.searchModeOn = false;
    }
  }
  crossClick()
  {
    this.searchNotes = "";
    this.searchModeOn = false;
  }
  updateCheckedOptions(option, $event)
  {
      if ($event.target.checked)
      {
        this.activeOptions.push(option.type);
      }
      else
      {
        this.activeOptions.splice(this.activeOptions.indexOf(option.type), 1);
      }
  }
   updateCheckState(element:any, event)
  {
      var allBoxes = element.optionsSecondary;
      if(event.target.checked)
      {
        for(var i =0; i<allBoxes.length;i++)
        {
          (<HTMLInputElement>document.getElementById(allBoxes[i].id)).checked = true;
          this.activeOptions.push(allBoxes[i].type);
        }
      }
      else
      {
        for(var i =0; i<allBoxes.length;i++)
        {
            (<HTMLInputElement>document.getElementById(allBoxes[i].id)).checked = false;
            this.activeOptions.splice(this.activeOptions.indexOf(allBoxes[i].type), 1);
        }
      }
  }
  showNoteInPopUp(note,index)
  {
    console.log(note);
    this.noteIndex = index + 1;
    this.showFullNote = true;
    this.fullNote = note;
  }
  closePop()
  {
    this.noteIndex = 0;
    this.showFullNote=false;
    this.fullNote={};
  }

  @HostListener('unloaded')
  ngOnDestroy(): void {
    this.userInfoSubscription.unsubscribe();
  }
}
